module.exports = __webpack_public_path__ + "static/media/banner.dd8549ed.jpg";